//CSSをバンドル
import 'Src/scss/courseform-calendar.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'

//モーダルを最初は隠す
// $('.modalCalendar').hide(); 

//モーダルの表示を変数で管理
let modalFadein = () => {
  $('.modalCalendar').fadeIn(400);
};
//モーダルの非表示を変数で管理
let modalFadeOut = () => {
  $('.modalCalendar').fadeOut(400);
};

$('.detail').on('click', function() {
    modalFadein();
    $('body').addClass('modal-open');
});


$('.modalCalendar__bk, .modalCalendar__whiteCloseBtn').on('click',function() {
  modalFadeOut();
  $('body').removeClass('modal-open');
});
$( '.modalCalendar__card' ).on( 'click', function( e ){
  e.stopPropagation();
} );




$('.modalCalendar__btn__scroll').on('click', function(e) {
  e.preventDefault();
  var isPosition = $('#modalCalendar__scroll').position();
  console.log(isPosition);
  $(".modalCalendar__card").animate({scrollTop:isPosition.top - 30}, 500);
});
